const courtDecisionsSelector = (state) => state.courtDecision.courtDecisions

export { courtDecisionsSelector }
